export default function Termos() {
  return (
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-20 max-w-4xl">
      <h1 className="text-4xl font-heading font-bold mb-8">Termos de Uso</h1>
      <div className="prose prose-slate dark:prose-invert max-w-none space-y-6">
        <p className="text-muted-foreground">
          Ao usar a LEILIZE, você concorda com os seguintes termos e condições.
        </p>
        
        <h2 className="text-2xl font-heading font-bold mt-8">1. Uso do Serviço</h2>
        <p>Nosso serviço é fornecido "como está" para fins informativos. As estimativas não constituem aconselhamento financeiro.</p>
        
        <h2 className="text-2xl font-heading font-bold mt-8">2. Limitação de Responsabilidade</h2>
        <p>Não nos responsabilizamos por decisões de compra baseadas em nossas análises. Recomendamos sempre realizar inspeções físicas.</p>
        
        <h2 className="text-2xl font-heading font-bold mt-8">3. Propriedade Intelectual</h2>
        <p>Todo conteúdo e algoritmos são propriedade da LEILIZE e protegidos por direitos autorais.</p>
      </div>
    </div>
  );
}
